// import React, { useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
// } from "recharts";

// import { PrAnalysisApi } from "../../../../../api/Api";

// const PrAnalysisTab1 = () => {
//   const [chartData, setChartData] = useState([]);

//   const credentials = {
//     USER: sessionStorage.getItem("LoginID") || "",
//     LCODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "XYZ",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
//     DT1: "24-JAN-2025", // Default Start Date
//     DT2: "25-JAN-2025", // Default End Date
//   };

//   // Fetch data from the API
//   const fetchLogData = async () => {
//     try {
//       const res = await PrAnalysisApi(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         console.log("Fetched Data:", res.data);

//         // Transform the API data into recharts format
//         const transformedData = res.data.map((item) => ({
//           name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
//           PR: parseFloat(item.PR) || 0, // PR value
//           CUF: parseFloat(item.CUF) || 0, // CUF value
//         }));

//         setChartData(transformedData);

//       } else {
//         console.error("Data structure mismatch:", res);
//         setChartData([]); // Handle invalid data response
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     }
//   };

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchLogData();
//   }, [credentials.USER]);

//   return (
//     <div style={{ width: "100%", height: 480, position: "relative" }}>
//       {/* Y-Axis Label for PR */}
//       {/* <div
//         style={{
//           position: "absolute",
//           top: "150px",
//           left: "0px",
//           fontSize: "12px",
//           fontWeight: "bold",
//           color: "#333",
//           transform: "rotate(-90deg)",
//           transformOrigin: "right",
//         }}
//       >
//         PR
//       </div> */}

//       {/* Y-Axis Label for CUF */}
//       {/* <div
//         style={{
//           position: "absolute",
//           top: "250px",
//           right: "40px",
//           fontSize: "12px",
//           fontWeight: "bold",
//           color: "#ff0000",
//           transform: "rotate(90deg)",
//           transformOrigin: "right",
//         }}
//       >
//         CUF
//       </div> */}

//       {/* Chart */}
//       <ResponsiveContainer>
//         <ComposedChart
//           data={chartData}
//           margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="name" />
//           <YAxis yAxisId="left" label={{ value: "PR", angle: -90, position: "insideLeft" }} />
//           <YAxis yAxisId="right" orientation="right" label={{ value: "CUF", angle: 90, position: "insideRight" }} />
//           <Tooltip />

//           {/* PR Bar */}
//           <Bar dataKey="PR" fill="#808080" name="PR" yAxisId="left">
//             <LabelList
//                dataKey="PR"
//               position="top"
//               style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
//             />
//           </Bar>

//           {/* CUF Line */}
//           <Line
//             type="monotone"
//             dataKey="CUF"
//             stroke="#ff0000"
//             name="CUF"
//             yAxisId="right"
//           >
//             <LabelList
//               dataKey="CUF"
//               position="top"
//               style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
//             />
//           </Line>
//         </ComposedChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default PrAnalysisTab1;


import React, { useEffect, useRef, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend
} from "recharts";
import { PrAnalysisApi } from "../../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button,
  IconButton
} from "@mui/material";

import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";


// 1.


// // Function to get default dates
// export function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
//   const tenDaysAgo = new Date(date);
//   tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
//   const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

//   return {
//     Today: formattedCurrentDate,
//     LastDay: formattedTenDaysAgo,
//   };
// }

// const Tab8ChartContent = () => {
//   const chartRef1 = useRef();
//   const chartRef2 = useRef();
//   const chartRef3 = useRef();
//   const chartRef4 = useRef();
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
//   const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//   const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//   const [chartData, setChartData] = useState([]);
//   const [chartData2, setChartData2] = useState([]);
//   const [chartData3, setChartData3] = useState([]);
//   const [chartData4, setChartData4] = useState([]);
//   const [chartData5, setChartData5] = useState([]);
//   const [chartData6, setChartData6] = useState([]);
//   const theme = useTheme();
//   const { palette, spacing, shape: { borderRadius } } = useTheme();

//   // LoggedInUserInfo null होने पर एरर से बचने के लिए सुरक्षित रंग (Fallback color)
//   const dashColor = LoggedInUserInfo?.dash_color || "#8884d8";

//   const credentials = {
//     USER: sessionStorage.getItem("LoginID") || "",
//     LCODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "XYZ",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
//     DT1: StartDate, // Default Start Date
//     DT2: EndDate, // Default End Date
//   };

//   // Fetch data from the API
//   const fetchLogData = async () => {
//     try {
//       const res = await PrAnalysisApi(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         // Transform the API data of Chart1
//         const transformedData = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           PR: parseFloat(item.PR) || 0,
//           CUF: parseFloat(item.CUF) || 0,
//         }));
//         setChartData(transformedData);

//         // Transform the API data of chart2
//         const transformedData2 = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           Solar_Insolation: parseFloat(item.Solar_Insolation) || 0,
//           PR: parseFloat(item.PR) || 0,
//         }));
//         setChartData2(transformedData2);

//         // Transform the API data of chart3
//         const transformedData3 = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           ENG: parseFloat(item.ENG) || 0,
//           CUF: parseFloat(item.CUF) || 0,
//         }));
//         setChartData3(transformedData3);

//         // Transform the API data of chart4
//         const transformedData4 = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           ENG: parseFloat(item.ENG) || 0,
//           Specific_Yield: parseFloat(item.Specific_Yield) || 0,
//         }));
//         setChartData4(transformedData4);

//         // Transform the API data of chart5
//         const transformedData5 = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           ENG: parseFloat(item.ENG) || 0,
//           Expected_Generation: parseFloat(item.Expected_Generation) || 0,
//         }));
//         setChartData5(transformedData5);

//         // Transform the API data of chart6
//         const transformedData6 = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           ENG: parseFloat(item.ENG) || 0,
//           PR: parseFloat(item.PR) || 0,
//         }));
//         setChartData6(transformedData6);

//       } else {
//         setChartData([]);
//         setChartData2([]);
//         setChartData3([]);
//         setChartData4([]);
//         setChartData5([]);
//         setChartData6([]);
//       }
//     } catch (err) {
//       // Handle error
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   // Handle Start Date change
//   const handleStartDateChange = (value) => {
//     setStartDate(value);
//   };

//   // Handle End Date change
//   const handleEndDateChange = (value) => {
//     setEndDate(value);
//   };

//   // Refresh data only when clicking "Show"
//   function onRefreshData() {
//     if (StartDate.length !== 0 && EndDate.length !== 0) {
//       fetchLogData();
//     } else {
//       alert("Please provide valid dates");
//     }
//   }

//   return (
//     <>
//       <Box bgcolor={""} py={2}>
//         <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
//           <Grid key="chart-grid" item xs={12}>
//             <Card>
//               <CardActions sx={{
//                 display: "flex",
//                 justify: "flex-end",
//                 alignItems: "center",
//                 gap: "16px",
//               }}>
//                 <label>
//                   From:&nbsp;
//                   <input
//                     type="date"
//                     value={StartDate}
//                     onChange={(e) => handleStartDateChange(e.target.value)}
//                     style={{
//                       padding: "2px 2px",
//                       borderRadius: "14px",
//                       border: "1px solid #ccc",
//                     }}
//                   />
//                 </label>
//                 <label>
//                   To:&nbsp;
//                   <input
//                     type="date"
//                     value={EndDate}
//                     onChange={(e) => handleEndDateChange(e.target.value)}
//                     style={{
//                       padding: "2px 2px",
//                       borderRadius: "14px",
//                       border: "1px solid #ccc",
//                     }}
//                   />
//                 </label>
//                 <IconButton
//                   onClick={onRefreshData}
//                   sx={{
//                     color: 'black',
//                     borderRadius: borderRadius,
//                     p: 1,
//                   }}
//                 >
//                   <RefreshIcon sx={{ fontSize: '24px' }} />
//                 </IconButton>
//               </CardActions>
//             </Card>
//           </Grid>
//         </Grid>

//         <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
//           <Grid item xs={12} md={6}>
//             <Card>
//               <Box
//                 sx={{
//                   padding: "4px",
//                   borderRadius: "5px",
//                   marginBottom: "15px",
//                   textAlign: "start",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                   border: "1px solid lightgray",
//                   display: "flex",
//                   alignItems: "center",
//                   justify: "space-between"
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                   <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
//                   Energy Generation[KWh]
//                 </Box>
//                 <DownloadJpegButton targetRef={chartRef1} fileName={`Energy Generation[KWh].jpeg`}/>
//               </Box>

//               <CardContent ref={chartRef1} sx={{ padding: "2px" }}>
//                 {chartData3.length > 0 ? (
//                   <ResponsiveContainer width="100%" height={400}>
//                     <ComposedChart
//                       data={chartData3}
//                       margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
//                     >
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="name" />
//                       <YAxis
//                         yAxisId="left"
//                         label={{
//                           value: "ENG",
//                           angle: -90,
//                           position: "insideLeft",
//                         }}
//                       />
//                       <Tooltip />
//                       <Legend
//                         layout="horizontal"
//                         verticalAlign="top"
//                         align="center"
//                         wrapperStyle={{
//                           paddingBottom: "10px",
//                           fontSize: "12px",
//                         }}
//                       />
//                       {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
//                       <Bar
//                         dataKey="ENG"
//                         fill={dashColor}
//                         name="Energy Generation"
//                         yAxisId="left"
//                       >
//                         <LabelList
//                           dataKey="ENG"
//                           position="top"
//                           style={{
//                             fill: dashColor,
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                           }}
//                         />
//                       </Bar>
//                     </ComposedChart>
//                   </ResponsiveContainer>
//                 ) : (
//                   <Typography variant="body1" color="textSecondary" textAlign="center">
//                     No data available for the selected range.
//                   </Typography>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <Card>
//               <Box
//                 sx={{
//                   padding: "4px",
//                   borderRadius: "5px",
//                   marginBottom: "15px",
//                   textAlign: "start",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                   border: "1px solid lightgray",
//                   display: "flex",
//                   alignItems: "center",
//                   justify: "space-between"
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                   <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
//                   CUF Curve
//                 </Box>
//                 <DownloadJpegButton targetRef={chartRef2} fileName={`CUF Curve.jpeg`} />
//               </Box>

//               <CardContent ref={chartRef2} sx={{ padding: "2px" }}>
//                 {chartData3.length > 0 ? (
//                   <ResponsiveContainer width="100%" height={400}>
//                     <ComposedChart
//                       data={chartData3}
//                       margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
//                     >
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="name" />
//                       <YAxis
//                         yAxisId="right"
//                         orientation="right"
//                         label={{
//                           value: "CUF",
//                           angle: 90,
//                           position: "insideRight",
//                         }}
//                       />
//                       <Tooltip />
//                       <Legend
//                         layout="horizontal"
//                         verticalAlign="top"
//                         align="center"
//                         wrapperStyle={{
//                           paddingBottom: "10px",
//                           fontSize: "12px",
//                         }}
//                       />
//                       {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
//                       <Bar
//                         dataKey="CUF"
//                         fill={dashColor}
//                         name="CUF"
//                         yAxisId="right"
//                       >
//                         <LabelList
//                           dataKey="CUF"
//                           position="top"
//                           style={{
//                             fill: dashColor,
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                           }}
//                         />
//                       </Bar>
//                     </ComposedChart>
//                   </ResponsiveContainer>
//                 ) : (
//                   <Typography variant="body1" color="textSecondary" textAlign="center">
//                     No data available for the selected range.
//                   </Typography>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </Box>

//       <Box bgcolor={"background.default"} py={2}>
//         <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
//           <Grid key="chart-grid" item xs={12}>
//             <Card>
//               <CardActions sx={{
//                 display: "flex",
//                 justify: "flex-end",
//                 alignItems: "center",
//                 gap: "16px",
//               }}>
//                 <label>
//                   <input
//                     type="date"
//                     value={StartDate}
//                     onChange={(e) => handleStartDateChange(e.target.value)}
//                     style={{
//                       padding: "2px 2px",
//                       borderRadius: "14px",
//                       border: "1px solid #ccc",
//                     }}
//                   />
//                 </label>
//                 <label>
//                   To
//                   <input
//                     type="date"
//                     value={EndDate}
//                     onChange={(e) => handleEndDateChange(e.target.value)}
//                     style={{
//                       padding: "2px 2px",
//                       borderRadius: "14px",
//                       border: "1px solid #ccc",
//                     }}
//                   />
//                 </label>
//                 <IconButton
//                   onClick={onRefreshData}
//                   sx={{
//                     color: 'black',
//                     borderRadius: borderRadius,
//                     p: 1,
//                   }}
//                 >
//                   <RefreshIcon sx={{ fontSize: '24px' }} />
//                 </IconButton>
//               </CardActions>
//             </Card>
//           </Grid>
//         </Grid>

//         <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
//           <Grid item xs={12} md={6}>
//             <Card>
//               <Box
//                 sx={{
//                   padding: "4px",
//                   borderRadius: "5px",
//                   marginBottom: "15px",
//                   textAlign: "start",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                   border: "1px solid lightgray",
//                   display: "flex",
//                   alignItems: "center",
//                   justify: "space-between"
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                   <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
//                   Energy Generation[KWh] Vs. CUF Curve
//                 </Box>
//                 <DownloadJpegButton targetRef={chartRef3} fileName={`Energy Generation[KWh] Vs. CUF Curve.jpeg`}/>
//               </Box>

//               <CardContent ref={chartRef3} sx={{ padding: "2px" }}>
//                 {chartData3.length > 0 ? (
//                   <ResponsiveContainer width="100%" height={400}>
//                     <ComposedChart
//                       data={chartData3}
//                       margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
//                     >
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="name" />
//                       <YAxis
//                         yAxisId="left"
//                         label={{
//                           value: "ENG",
//                           angle: -90,
//                           position: "insideLeft",
//                         }}
//                       />
//                       <YAxis
//                         yAxisId="right"
//                         orientation="right"
//                         label={{
//                           value: "CUF",
//                           angle: 90,
//                           position: "insideRight",
//                         }}
//                       />
//                       <Tooltip />
//                       <Legend
//                         layout="horizontal"
//                         verticalAlign="top"
//                         align="center"
//                         wrapperStyle={{
//                           paddingBottom: "10px",
//                           fontSize: "12px",
//                         }}
//                       />
//                       {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
//                       <Bar
//                         dataKey="ENG"
//                         fill={dashColor}
//                         name="Energy Generation"
//                         yAxisId="left"
//                       >
//                         <LabelList
//                           dataKey="ENG"
//                           position="top"
//                           style={{
//                             fill: dashColor,
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                           }}
//                         />
//                       </Bar>

//                       <Line
//                         type="monotone"
//                         dataKey="CUF"
//                         stroke="#808080"
//                         name="CUF"
//                         yAxisId="right"
//                       >
//                         <LabelList
//                           dataKey="CUF"
//                           position="top"
//                           style={{
//                             fill: "#808080",
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                           }}
//                         />
//                       </Line>
//                     </ComposedChart>
//                   </ResponsiveContainer>
//                 ) : (
//                   <Typography variant="body1" color="textSecondary" textAlign="center">
//                     No data available for the selected range.
//                   </Typography>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <Card>
//               <Box
//                 sx={{
//                   padding: "4px",
//                   borderRadius: "5px",
//                   marginBottom: "15px",
//                   textAlign: "start",
//                   fontWeight: "bold",
//                   fontSize: "16px",
//                   border: "1px solid lightgray",
//                   display: "flex",
//                   alignItems: "center",
//                   justify: "space-between"
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                   <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
//                   Energy Generation[KWh] Vs. Specific Yield
//                 </Box>
//                 <DownloadJpegButton targetRef={chartRef4} fileName={`Energy Generation[KWh] Vs. Specific Yield.jpeg`}/>
//               </Box>

//               <CardContent ref={chartRef4} sx={{ padding: "2px" }}>
//                 {chartData3.length > 0 ? (
//                   <ResponsiveContainer width="100%" height={400}>
//                     <ComposedChart
//                       data={chartData4}
//                       margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
//                     >
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="name" />
//                       <YAxis
//                         yAxisId="left"
//                         label={{
//                           value: "ENG",
//                           angle: -90,
//                           position: "insideLeft",
//                         }}
//                       />
//                       <YAxis
//                         yAxisId="right"
//                         orientation="right"
//                         label={{
//                           value: "Specific_Yield",
//                           angle: 90,
//                           position: "insideRight",
//                         }}
//                       />
//                       <Tooltip />
//                       <Legend
//                         layout="horizontal"
//                         verticalAlign="top"
//                         align="center"
//                         wrapperStyle={{
//                           paddingBottom: "10px",
//                           fontSize: "12px",
//                         }}
//                       />
//                       {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
//                       <Bar
//                         dataKey="ENG"
//                         fill={dashColor}
//                         name="Energy Generation"
//                         yAxisId="left"
//                       >
//                         <LabelList
//                           dataKey="ENG"
//                           position="top"
//                           style={{
//                             fill: dashColor,
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                           }}
//                         />
//                       </Bar>

//                       <Line
//                         type="monotone"
//                         dataKey="Specific_Yield"
//                         stroke="#808080"
//                         name="Specific_Yield"
//                         yAxisId="right"
//                       >
//                         <LabelList
//                           dataKey="Specific_Yield"
//                           position="top"
//                           style={{
//                             fill: "#808080",
//                             fontSize: "12px",
//                             fontWeight: "bold",
//                           }}
//                         />
//                       </Line>
//                     </ComposedChart>
//                   </ResponsiveContainer>
//                 ) : (
//                   <Typography variant="body1" color="textSecondary" textAlign="center">
//                     No data available for the selected range.
//                   </Typography>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </Box>
//     </>
//   );
// };

// export default Tab8ChartContent;



// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

const Tab8ChartContent = () => {
  const chartRef1 = useRef();
  const chartRef2 = useRef();
  const chartRef3 = useRef();
  const chartRef4 = useRef();
  const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

  const [chartData, setChartData] = useState([]);
  const [chartData2, setChartData2] = useState([]);
  const [chartData3, setChartData3] = useState([]);
  const [chartData4, setChartData4] = useState([]);
  const [chartData5, setChartData5] = useState([]);
  const [chartData6, setChartData6] = useState([]);
  const theme = useTheme();
  const { palette, spacing, shape: { borderRadius } } = useTheme();

  // LoggedInUserInfo null होने पर एरर से बचने के लिए सुरक्षित रंग (Fallback color)
  const dashColor = LoggedInUserInfo?.dash_color || "#8884d8";

  const credentials = {
    USER: sessionStorage.getItem("LoginID") || "",
    LCODE: sessionStorage.getItem("LCODE") || "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate, // Default Start Date
    DT2: EndDate, // Default End Date
  };

  // Fetch data from the API
  const fetchLogData = async () => {
    try {
      const res = await PrAnalysisApi(credentials);

      if (res?.data && Array.isArray(res.data)) {
        // Transform the API data of Chart1
        const transformedData = res.data.map((item) => ({
          name: item.DATET || "N/A",
          PR: parseFloat(item.PR) || 0,
          CUF: parseFloat(item.CUF) || 0,
        }));
        setChartData(transformedData);

        // Transform the API data of chart2
        const transformedData2 = res.data.map((item) => ({
          name: item.DATET || "N/A",
          Solar_Insolation: parseFloat(item.Solar_Insolation) || 0,
          PR: parseFloat(item.PR) || 0,
        }));
        setChartData2(transformedData2);

        // Transform the API data of chart3
        const transformedData3 = res.data.map((item) => ({
          name: item.DATET || "N/A",
          ENG: parseFloat(item.ENG) || 0,
          CUF: parseFloat(item.CUF) || 0,
        }));
        setChartData3(transformedData3);

        // Transform the API data of chart4
        const transformedData4 = res.data.map((item) => ({
          name: item.DATET || "N/A",
          ENG: parseFloat(item.ENG) || 0,
          Specific_Yield: parseFloat(item.Specific_Yield) || 0,
        }));
        setChartData4(transformedData4);

        // Transform the API data of chart5
        const transformedData5 = res.data.map((item) => ({
          name: item.DATET || "N/A",
          ENG: parseFloat(item.ENG) || 0,
          Expected_Generation: parseFloat(item.Expected_Generation) || 0,
        }));
        setChartData5(transformedData5);

        // Transform the API data of chart6
        const transformedData6 = res.data.map((item) => ({
          name: item.DATET || "N/A",
          ENG: parseFloat(item.ENG) || 0,
          PR: parseFloat(item.PR) || 0,
        }));
        setChartData6(transformedData6);

      } else {
        setChartData([]);
        setChartData2([]);
        setChartData3([]);
        setChartData4([]);
        setChartData5([]);
        setChartData6([]);
      }
    } catch (err) {
      // Handle error
    }
  };

  useEffect(() => {
    fetchLogData();
  }, []);

  // Handle Start Date change
  const handleStartDateChange = (value) => {
    setStartDate(value);
  };

  // Handle End Date change
  const handleEndDateChange = (value) => {
    setEndDate(value);
  };

  // Refresh data only when clicking "Show"
  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData();
    } else {
      alert("Please provide valid dates");
    }
  }

  return (
    <>
      <Box bgcolor={""} py={2}>
        <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
          <Grid key="chart-grid" item xs={12}>
            <Card>
              <CardActions sx={{
                display: "flex",
                justify: "flex-end",
                alignItems: "center",
                gap: "16px",
              }}>
                <label>
                  From:&nbsp;
                  <input
                    type="date"
                    value={StartDate}
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <label>
                  To:&nbsp;
                  <input
                    type="date"
                    value={EndDate}
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <IconButton
                  onClick={onRefreshData}
                  sx={{
                    color: 'black',
                    borderRadius: borderRadius,
                    p: 1,
                  }}
                >
                  <RefreshIcon sx={{ fontSize: '24px' }} />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <Card>
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                  justify: "space-between"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                  Energy Generation[KWh]
                </Box>
                <DownloadJpegButton targetRef={chartRef1} fileName={`Energy Generation[KWh].jpeg`}/>
              </Box>

              <CardContent ref={chartRef1} sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData3}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis
                        yAxisId="left"
                        label={{
                          value: "ENG",
                          angle: -90,
                          position: "insideLeft",
                        }}
                      />
                      <Tooltip />
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px",
                          fontSize: "12px",
                        }}
                      />
                      {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
                      <Bar
                        dataKey="ENG"
                        fill={dashColor}
                        name="Energy Generation"
                        yAxisId="left"
                      >
                        <LabelList
                          dataKey="ENG"
                          position="top"
                          style={{
                            fill: dashColor,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography variant="body1" color="textSecondary" textAlign="center">
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                  justify: "space-between"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                  CUF Curve
                </Box>
                <DownloadJpegButton targetRef={chartRef2} fileName={`CUF Curve.jpeg`} />
              </Box>

              <CardContent ref={chartRef2} sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData3}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        label={{
                          value: "CUF",
                          angle: 90,
                          position: "insideRight",
                        }}
                      />
                      <Tooltip />
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px",
                          fontSize: "12px",
                        }}
                      />
                      {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
                      <Bar
                        dataKey="CUF"
                        fill={dashColor}
                        name="CUF"
                        yAxisId="right"
                      >
                        <LabelList
                          dataKey="CUF"
                          position="top"
                          style={{
                            fill: dashColor,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography variant="body1" color="textSecondary" textAlign="center">
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Box bgcolor={"background.default"} py={2}>
        <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
          <Grid key="chart-grid" item xs={12}>
            <Card>
              <CardActions sx={{
                display: "flex",
                justify: "flex-end",
                alignItems: "center",
                gap: "16px",
              }}>
                <label>
                  <input
                    type="date"
                    value={StartDate}
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <label>
                  To
                  <input
                    type="date"
                    value={EndDate}
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <IconButton
                  onClick={onRefreshData}
                  sx={{
                    color: 'black',
                    borderRadius: borderRadius,
                    p: 1,
                  }}
                >
                  <RefreshIcon sx={{ fontSize: '24px' }} />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <Card>
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                  justify: "space-between"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                  Energy Generation[KWh] Vs. CUF Curve
                </Box>
                <DownloadJpegButton targetRef={chartRef3} fileName={`Energy Generation[KWh] Vs. CUF Curve.jpeg`}/>
              </Box>

              <CardContent ref={chartRef3} sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData3}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis
                        yAxisId="left"
                        label={{
                          value: "ENG",
                          angle: -90,
                          position: "insideLeft",
                        }}
                      />
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        label={{
                          value: "CUF",
                          angle: 90,
                          position: "insideRight",
                        }}
                      />
                      <Tooltip />
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px",
                          fontSize: "12px",
                        }}
                      />
                      {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
                      <Bar
                        dataKey="ENG"
                        fill={dashColor}
                        name="Energy Generation"
                        yAxisId="left"
                      >
                        <LabelList
                          dataKey="ENG"
                          position="top"
                          style={{
                            fill: dashColor,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>

                      <Line
                        type="monotone"
                        dataKey="CUF"
                        stroke="#808080"
                        name="CUF"
                        yAxisId="right"
                      >
                        <LabelList
                          dataKey="CUF"
                          position="top"
                          style={{
                            fill: "#808080",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Line>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography variant="body1" color="textSecondary" textAlign="center">
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                  justify: "space-between"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                  Energy Generation[KWh] Vs. Specific Yield
                </Box>
                <DownloadJpegButton targetRef={chartRef4} fileName={`Energy Generation[KWh] Vs. Specific Yield.jpeg`}/>
              </Box>

              <CardContent ref={chartRef4} sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData4}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis
                        yAxisId="left"
                        label={{
                          value: "ENG",
                          angle: -90,
                          position: "insideLeft",
                        }}
                      />
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        label={{
                          value: "Specific_Yield",
                          angle: 90,
                          position: "insideRight",
                        }}
                      />
                      <Tooltip />
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px",
                          fontSize: "12px",
                        }}
                      />
                      {/* यहाँ dashColor वेरिएबल का इस्तेमाल किया गया है */}
                      <Bar
                        dataKey="ENG"
                        fill={dashColor}
                        name="Energy Generation"
                        yAxisId="left"
                      >
                        <LabelList
                          dataKey="ENG"
                          position="top"
                          style={{
                            fill: dashColor,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>

                      <Line
                        type="monotone"
                        dataKey="Specific_Yield"
                        stroke="#808080"
                        name="Specific_Yield"
                        yAxisId="right"
                      >
                        <LabelList
                          dataKey="Specific_Yield"
                          position="top"
                          style={{
                            fill: "#808080",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Line>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography variant="body1" color="textSecondary" textAlign="center">
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Tab8ChartContent;
